const fDropdown = () => {
  const aDropdowns = document.querySelectorAll('.js-dropdown');

  const closeDropdowns = (dropdowns) => {
    dropdowns.forEach((dropdown) => {
      dropdown.querySelector('.dropdown__toggle').classList.remove('dropdown__toggle--open');
      dropdown.querySelector('.dropdown__list').classList.remove('dropdown__list--open');
    });
  };

  const toggleDropdown = (toggle, list) => {
    if (list.classList.contains('dropdown__list--open')) {
      list.classList.remove('dropdown__list--open');
      toggle.classList.remove('dropdown__toggle--open');
    } else {
      list.classList.add('dropdown__list--open');
      toggle.classList.add('dropdown__toggle--open');
    }
  };

  const setActiveDropdownItem = (item, toggle, sub) => {
      const itemText = item.querySelector('.dropdown__list__link__text').innerHTML; //.textContent;
    const toggleText = toggle.querySelector('.dropdown__toggle__text');

      //toggleText.textContent = itemText;

      toggleText.innerHTML = itemText;
  };

  const addDropdownLinkHandler = (link, toggle, list) => {
    link.addEventListener('click', () => {
      if (link.classList.contains('js-dropdown-sub')) {
        const oSubList = link.nextElementSibling;
        toggleDropdown(link, oSubList);
      } else {
        setActiveDropdownItem(link, toggle);
        toggleDropdown(toggle, list);
      }
    });
  };

  const createDropdown = (dropdown) => {
    const oDropdownToggle = dropdown.querySelector('.dropdown__toggle');
    const oDropdownList = dropdown.querySelector('.dropdown__list');
    const aDropdownLinks = oDropdownList.querySelectorAll('.dropdown__list__link');

    oDropdownToggle.addEventListener('click', () => {
      toggleDropdown(oDropdownToggle, oDropdownList);
    });

    for (let i = 0; i < aDropdownLinks.length; i += 1) {
      addDropdownLinkHandler(aDropdownLinks[i], oDropdownToggle, oDropdownList);
    }
  };

  window.addEventListener('click', (e) => {
    if (!e.target.closest('.dropdown__toggle--open') && !e.target.classList.contains('js-dropdown-sub')) {
        closeDropdowns(aDropdowns);

        const link = e.target.closest('a[href="#"]');

        if (link === null) {
            return;
        }

        e.preventDefault();
    }
  });

  for (let i = 0; i < aDropdowns.length; i += 1) {
    createDropdown(aDropdowns[i]);
  }
};
